import { render, staticRenderFns } from "./OtsTableNew.vue?vue&type=template&id=29f24dc3&scoped=true&"
import script from "./OtsTableNew.vue?vue&type=script&lang=js&"
export * from "./OtsTableNew.vue?vue&type=script&lang=js&"
import style0 from "./OtsTableNew.vue?vue&type=style&index=0&id=29f24dc3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f24dc3",
  null
  
)

export default component.exports